import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GlobalsStore } from '../../../stores/globals.state';
import { Colorset } from '../../../models/colorset';
import { Button, ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-table-row-colorset]',
  standalone: true,
  imports: [Button, ButtonDirective, RouterLink],
  templateUrl: './table-row-colorset.component.html',
  styleUrl: './table-row-colorset.component.scss',
})
export class TableRowColorsetComponent {
  readonly globalStore = inject(GlobalsStore);
  readonly activeUserStore = inject(ActiveUserStore);
  @Input() item!: Colorset;
  @Output() closeEvent = new EventEmitter<void>();

  closeParent(): void {
    this.closeEvent.emit();
  }
}
